/** Buchungsstatus – spiegelt api/core/booking_status.py */
export type BookingStatus =
  | "draft"
  | "requested"
  | "reserved"
  | "confirmed"
  | "checked_in"
  | "checked_out"
  | "cancelled"
  | "rejected"
  | "no_show";

export const BOOKING_STATUS_LABELS: Record<BookingStatus, string> = {
  draft: "Entwurf",
  requested: "Angefragt",
  reserved: "Reserviert",
  confirmed: "Bestätigt",
  checked_in: "Eingecheckt",
  checked_out: "Ausgecheckt",
  cancelled: "Storniert",
  rejected: "Abgelehnt",
  no_show: "Nicht erschienen",
};

export function bookingStatusLabel(status: string): string {
  const key = status.toLowerCase().replace(/\s+/g, "_") as BookingStatus;
  return BOOKING_STATUS_LABELS[key] ?? status.replace(/_/g, " ");
}
